import React from 'react'
import { useNavigate, useParams } from 'react-router-dom'

import { useNavigation } from 'modules/core/hooks/useNavigation'
import { track, trackingEvents } from 'modules/core/lib/Tracking'

import ProcessSidePanel from 'modules/processes/components/ProcessSidePanel'

const CreateCustomProcessModalPage = () => {
  const navigate = useNavigate()
  const { navigation } = useNavigation()
  const { category } = useParams()

  const onClose = () => {
    navigate(-1)
  }

  const onSuccess = (processId: number) => {
    if (!category) return

    track(trackingEvents.processes.newCustomWorkflowSaved, {
      category: category,
      processId,
    })

    navigate(
      navigation.processes.template.id.settings.fullPath({
        category: category,
        id: processId,
      }),
      { replace: true }
    )
  }

  return <ProcessSidePanel onClose={onClose} onSuccess={onSuccess} />
}

export default CreateCustomProcessModalPage
